import Cookie from './helpers/Cookies';
import { cookiesName, cookieExpiration } from './constants';

const cartHook = document.querySelector('#cart');
if (
  cartHook &&
  cartHook.dataset.freeitemActiveByParameter === 'true' &&
  window?.cartData?.parameters?.length
) {
  const setCookieForFreeChainViaParameter = () => {
    for (const item of window?.cartData?.parameters) {
      // const itemSplited = item.split("|");
      const { parameter, product } = item;

      const activationFreeProductByParameter =
        new URL(window.location.href).searchParams.get(parameter) !== null ||
        Cookie.get(`${cookiesName.offer.freeItemByParameterPrefix}${parameter}`);

      if (activationFreeProductByParameter && product) {
        if (
          !Cookie.get(
            `${cookiesName.offer.freeItemByParameterPrefix}${parameter}`
          )
        ) {
          Cookie.set({
            name: `${cookiesName.offer.freeItemByParameterPrefix}${parameter}`,
            value: true,
            expires: cookieExpiration[cookiesName.offer.freeItemByParameterPrefix],
            path: '/',
          });
        }

        break;
      }
    }
  };

  setCookieForFreeChainViaParameter();
}
